<template>
  <div id="app">
    <template v-if="!isVerifying">
      <Header v-if="adminLoggedInfo"></Header>
      <router-view/>
      <Footer v-if="adminLoggedInfo"></Footer>
      <Notification></Notification>
      <Confirm></Confirm>
      <Loading></Loading>
    </template>
    <Verify></Verify>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import Notification from '@/components/Notification'
  import Confirm from "@/components/Confirm"
  import Loading from '@/components/Loading'
  import Verify from '@/components/Verify'
  import { mapState } from 'vuex'

  export default {
    name: 'app',
    components: {
      Header,
      Footer,
      Notification,
      Confirm,
      Loading,
      Verify
    },
    data() {
      return {
        isShow: false
      }
    },
    created () {
      let token = localStorage.getItem('token')
      let currentPath = this.$route.path

      if (currentPath !== '/login' && currentPath !== '/forgot') {
        if (!token) {
          if(currentPath === '/account/delete'){
            //
          }else{
            this.$router.push('/login')
          }

        } else {
          let successCallback = (response) => {
            if (response.data.data.role === 2) {
              this.$router.push('/parent/select-bus')
            } else {
              if (currentPath === '/login' || currentPath === '/') {
                this.$router.push('/bus')
              }
            }
          }

          let errorCallback = () => {
            localStorage.removeItem('token')
            this.$router.push('/login')
          }

          let payload = {
            successCallback,
            errorCallback,
            token
          }

          this.$store.dispatch('login/verify', payload)
        }
      }
    },
    mounted() {
    },
    watch: {
      '$route'(to, from) {
        if (to.path.includes('/login')) {
          this.isShow = false
        } else {
          this.isShow = true
        }
      },
    },
    computed: {
      ...mapState('login', ['isVerifying', 'adminLoggedInfo'])
    },
    sockets: {
      notifications (notification) {
        this.$store.commit('login/addUnreadNotification', { notification })
      },
      notificationRead (notification) {
        this.$store.commit('login/readNotification', { notification })
      }
    }
  }
</script>

<style>
  body {
    margin: 0px !important;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #main-content:after {
    display: block;
    content: '';
    clear: both;
  }

  button, a {
    outline: none!important;
  }

  .error {
    color: #ff0000;
  }
</style>
